import { Alert, Button, Checkbox, Col, Form, FormInstance, Input, InputNumber, message, Row, Select, Collapse, Divider, Tag, Space, Typography } from "antd"
import TextArea from "antd/es/input/TextArea"
import React, { useEffect, useRef, useState } from "react"
import { useRegister } from "../../contexts/RegisterContext"
import { formatInputNumber, parseInputNumber, roundValue } from "../../utils"
import { MinusCircleOutlined, BarcodeOutlined, SettingOutlined } from "@ant-design/icons"
import BarcodeScannerModal from "../modals/BarcodeScannerModal"
import { useBarcodeScanner } from "../../hooks/useBarcodeScanner"
import { useConfig } from "../../contexts/ConfigContext"
import { modules } from "../../config/pages"
import useAuth from "../../hooks/useAuth"
import { useItems, useStoreFetch } from "../../hooks/useInventory"
import { useCompany } from "../../contexts/CompanyContext"
import { useStore } from "../../contexts/StoreContext"
import { TElementModuleOptions, TModuleOptions } from "../../models/storageModel"
import ItemImageUploader from "../common/ItemImageUploader"
type formProps = {
  form: FormInstance
  getFormTaxes: (values:any, type:"sell" | "purchase") => Partial<TElementModuleOptions>[]
}

function RegisterInventoryItemForm({form,getFormTaxes}:Readonly<formProps>){
  const { Option } = Select
  const {register} = useRegister()
  const {config} = useConfig()
  const {company} = useCompany()
  const {updateStore} = useStore()
  // Use refs to maintain unique counters that never reset
  const idCounter = useRef(-1);
  const getNextId = () => --idCounter.current;
  const mod = config.module
  let {currentStorageItem: currentRegister} = register

  const [sellTaxes, setSellTaxes] = useState([{id: -1}]);
  const [purchaseTaxes, setPurchaseTaxes] = useState([{id: -1}]);
  const categories = register.categoryOptions.filter(el => {
    if (mod === modules.EditStorageItem && el.key === currentRegister?.category) {
      return true;
    }
    return el.show !== false;
  })
  const sellTaxesOptions = register.taxesOptions.filter(el => {
    if (mod === modules.EditStorageItem) {
      const isAssigned = currentRegister?.module_options?.some(opt => opt.option_id === el.id && opt.sub_type === "SELL_TAX");
      if (isAssigned) return true;
    }
    return el.show !== false;
  })
  const purchaseTaxesOptions = register.taxesOptions.filter(el => {
    if (mod === modules.EditStorageItem) {
      const isAssigned = currentRegister?.module_options?.some(opt => opt.option_id === el.id && opt.sub_type === "PURCHASE_TAX");
      if (isAssigned) return true;
    }
    return el.show !== false;
  })
  const presentations = register.displayOptions.filter(el => {
    if (mod === modules.EditStorageItem && el.key === currentRegister?.display) {
      return true;
    }
    return el.show !== false;
  })
  const ums = register.umOptions.filter(el => {
    if (mod === modules.EditStorageItem && el.key === currentRegister?.measure_unit) {
      return true;
    }
    return el.show !== false;
  })
  const [otherValues, setOtherValues] = useState([{id: -1}]);
  const [sellTaxesWarning, setSellTaxesWarning] = useState(false)
  const [purchaseTaxesWarning, setPurchaseTaxesWarning] = useState(false)
  const [otherValuesWarning, setOtherValuesWarning] = useState(false)
  const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key)
  const {data} = useStoreFetch(tokenData,{
    all:true,
    company:company.current.uid
  })
  const {data: itemsData} = useItems(tokenData,{
    company:company.current.uid,
    module: config.module
  })
  const parentItemsList = itemsData?.itemList || register.registerList || []
  const eligibleParentItems = parentItemsList.filter((item: any) => {
    const isService = item.register_type === "SERVICE";
    const isFixedAsset = item.register_type === "FIXED_ASSET";
    const isSelf = currentRegister?.id && String(item.id) === String(currentRegister.id);
    return !isService && !isFixedAsset && !isSelf;
  });

  const [isScannerOpen, setIsScannerOpen] = useState(false);

  // Handle global barcode scanner events
  const handleBarcodeScanned = (scannedBarcode: string) => {
    const currentBarcode = form.getFieldValue("barcode");
    if (!currentBarcode) {
      form.setFieldsValue({ barcode: scannedBarcode });
    }
  };

  useBarcodeScanner({ onScan: handleBarcodeScanned, isActive: !isScannerOpen });

  useEffect(()=>{
    //Asignar array de impuestos  y otros valores cuando se va a editar un registro
    const sellTaxes = currentRegister?.module_options?.filter(el => el.sub_type === "SELL_TAX").map(el => ({id: el.id || -1})) || []
    const purchaseTaxes = currentRegister?.module_options?.filter(el => el.sub_type === "PURCHASE_TAX").map(el => ({id: el.id || -1})) || []
    const otherValues = currentRegister?.other_values?.map(el => ({id: el.id || -1})) || []
    if(mod === modules.EditStorageItem && sellTaxes?.length) {
      setSellTaxes(sellTaxes)
    }
    if(mod === modules.EditStorageItem && purchaseTaxes?.length) {
      setPurchaseTaxes(purchaseTaxes)
    }
    if(mod === modules.EditStorageItem && otherValues?.length) {
      setOtherValues(otherValues)
    }
    if(mod === modules.EditStorageItem && currentRegister?.sell_price){
      handlePriceChange("sell")
    }
    if(mod === modules.EditStorageItem && currentRegister?.purchase_price){
      handlePriceChange("purchase")
    }
    if(data?.storehouse){
      updateStore({list: data.storehouse})
    }
  },[register,mod,data])
  
  const scanForEmptyFields = (data:any[],setData:any,setShoWarning:any,key:string)=>{
    const values = form.getFieldsValue()
    console.log("Values: ",values)
    let emptyValues = false
    for(const str in values){
      emptyValues = str.includes(key) && values[str] === undefined
      if(emptyValues) {
        break
      }
    }
    if(emptyValues){
      setShoWarning(true)
    }else{
      setData([...data, {id: getNextId() }]);
      setShoWarning(false)
    }
  }

  const removeSellTaxes = (id:number) => {
    if(id > 0){
      message.error("No se puede eliminar un impuesto que ya se encuentra registrado")
      return
    }
    const filterResult = sellTaxes.filter(item => item.id !== id)
    const result = filterResult.length ? filterResult : [{id: getNextId()}]
    form.setFieldsValue({
      [`sell_taxes_${id}`]: undefined,
      [`sell_taxes_active_${id}`]: undefined,
      sell_price_net: undefined,
      sell_price_full: undefined
    })
    setSellTaxes(result)
  }
  const removePurchaseTaxes = (id:number) => {
    if(id > 0){
      message.error("No se puede eliminar un impuesto que ya se encuentra registrado")
      return
    }
    const filterResult = purchaseTaxes.filter(item => item.id !== id)
    const result = filterResult.length ? filterResult : [{id: getNextId()}]
    form.setFieldsValue({
      [`purchase_taxes_${id}`]: undefined,
      [`purchase_taxes_active_${id}`]: undefined,
      purchase_price_net: undefined,
      purchase_price_full: undefined
    })
    setPurchaseTaxes(result)
  }
  const removeOtherValues = (id:number) => {
    if(id > 0){
      message.error("No se puede eliminar un campo que ya se encuentra registrado")
      return
    }
    const filterResult = otherValues.filter(item => item.id !== id)
    const result = filterResult.length ? filterResult : [{id: getNextId()}]
    form.setFieldsValue({
      [`otherValues_type_${id}`]: undefined,
      [`otherValues_value_${id}`]: undefined,
      [`otherValues_visible_${id}`]: undefined,
    })
    setOtherValues(result)
  }

  const allValues = Form.useWatch([], form);
  const checkedList = allValues?.registerOptions || ["SALE", "PURCHASE"];
  const sellDiscountValue = Form.useWatch("sell_discount", form);
  const purchaseDiscountValue = Form.useWatch("purchase_discount", form);
  const formImages = Form.useWatch("images", form);

  const disabledOption = (option:string, field:"sell_taxes" | "purchase_taxes") => {
    const values = form.getFieldsValue()
    for(const key in values){
      if(key.startsWith(field) && !key.includes("active") && values[key] === option){
        return true
      }
    }
    return false
  }

  const isFieldDisabled = (id: number, prefix: string) => {
    if (id <= 0) return false;
    return allValues?.[`${prefix}_active_${id}`] === false || allValues?.[`${prefix}_visible_${id}`] === false;
  };

  const handlePriceChange = (type: "sell" | "purchase", overrides: Record<string, any> = {}) => {
    const formValues = { ...form.getFieldsValue(), ...overrides }
    const value = formValues[`${type}_price`] || 0
    const keyFullPrice = type === "sell" ? "sell_price_full" : "purchase_price_full"
    const keyNetPrice = type === "sell" ? "sell_price_net" : "purchase_price_net"
    const keyDiscount = type === "sell" ? "sell_discount" : "purchase_discount"
    const AllTaxes = getFormTaxes({...formValues},type)
                    .filter(el => el.is_active)
                    .map(el => register.taxesOptions.find(tax => tax.id === el.option_id) as TModuleOptions)
                    .filter(Boolean)
    const rateTax = AllTaxes.filter(el => el.type === "TAX_RATE").reduce((sum, el) => sum + (el.numeric_value || 0), 0)
    const fixedTax = AllTaxes.filter(el => el.type === "TAX_FIXED").reduce((sum, el) => sum + (el.numeric_value || 0), 0)
    const discountRate = formValues[keyDiscount] || 0;
    const fullPrice = roundValue(value*(1+rateTax/100) + fixedTax)
    const netPrice = roundValue(value*(1-discountRate/100)*(1+rateTax/100) + fixedTax)
    form.setFieldsValue({ [keyFullPrice]: fullPrice, [keyNetPrice]: netPrice });
  };

  const isBarcodeDisabled = mod === modules.EditStorageItem && currentRegister?.barcode !== undefined && currentRegister?.barcode.length > 0;
  const isEdit = mod === modules.EditStorageItem;
  const hasAdvancedData = Boolean(
    currentRegister?.custom_id ||
    currentRegister?.barcode ||
    currentRegister?.sku ||
    currentRegister?.min_quantity ||
    currentRegister?.location ||
    currentRegister?.parent_element_id ||
    currentRegister?.conversion_factor ||
    sellTaxes.some(t => t.id > 0) ||
    purchaseTaxes.some(t => t.id > 0) ||
    otherValues.some(o => o.id > 0)
  );
  const defaultActiveCollapse = (isEdit && hasAdvancedData) ? ["advanced-options"] : [];

  return(
    <>
    {/* Campos Principales */}
    <Row gutter={[10, 10]}>
      <Col xs={24} sm={{span:20,offset:2}}>
        <Form.Item
          label="Nombre"
          name="name"
          rules={[{ required: true, message: 'Por favor ingresa el nombre' }]}
        >
          <Input placeholder="Ingresa el nombre"/>
        </Form.Item>
      </Col>

      {/* Galería de Imágenes */}
      <Col xs={24} sm={{ span: 20, offset: 2 }}>
        <Form.Item name="images" style={{ marginBottom: 12 }}>
          <ItemImageUploader
            elementId={currentRegister?.id}
            elementUid={currentRegister?.uid}
            value={formImages || currentRegister?.images || (currentRegister?.image ? [{ file_name: currentRegister.name || "Imagen principal", file_url: currentRegister.image, is_primary: true, display_order: 0, storage_path: "" }] : [])}
            onChange={(imgs, primaryUrl) => {
              form.setFieldsValue({
                images: imgs,
                image: primaryUrl || "",
                image_mini: primaryUrl || "",
              })
            }}
          />
        </Form.Item>
        <Form.Item name="image" hidden><Input /></Form.Item>
        <Form.Item name="image_mini" hidden><Input /></Form.Item>
      </Col>

      {checkedList.includes("SALE") && (
        <Col xs={24} sm={{ span: 20, offset: 2 }}>
          <Row gutter={[10, 10]}>
            <Col xs={24} sm={{ span: sellDiscountValue > 0 ? 8 : 12 }}>
              <Form.Item
                label="Precio de venta base"
                name="sell_price"
                rules={[{ required: true, message: 'Por favor ingresa el valor del item' }]}
              >
                <InputNumber
                  placeholder="Ingresa el valor"
                  prefix="$"
                  style={{ width: '100%' }}
                  formatter={formatInputNumber}
                  parser={parseInputNumber}
                  onChange={(val) => handlePriceChange("sell", { sell_price: val })}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={{ span: sellDiscountValue > 0 ? 8 : 12 }}>
              <Form.Item
                label="Precio de venta completo"
                name="sell_price_full"
                rules={[{ required: true, message: 'Por favor ingrese un valor' }]}
              >
                <InputNumber
                  placeholder="Ingresa el valor"
                  disabled
                  prefix="$"
                  style={{ width: '100%' }}
                  min={0}
                  formatter={formatInputNumber}
                  parser={parseInputNumber}
                />
              </Form.Item>
            </Col>
            {sellDiscountValue > 0 && (
              <Col xs={24} sm={{ span: 8 }}>
                <Form.Item
                  label="Precio con descuento"
                  name="sell_price_net"
                  rules={[{ required: true, message: 'Por favor ingrese un valor' }]}
                >
                  <InputNumber
                    placeholder="Ingresa el valor"
                    disabled
                    prefix="$"
                    style={{ width: '100%' }}
                    min={0}
                    formatter={formatInputNumber}
                    parser={parseInputNumber}
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
        </Col>
      )}

      {checkedList.includes("PURCHASE") && (
        <Col xs={24} sm={{ span: 20, offset: 2 }}>
          <Row gutter={[10, 10]}>
            <Col xs={24} sm={{ span: purchaseDiscountValue > 0 ? 8 : 12 }}>
              <Form.Item
                label="Precio de compra base"
                name="purchase_price"
                rules={[{ required: true, message: 'Por favor ingresa el valor del item' }]}
              >
                <InputNumber
                  placeholder="Ingresa el valor"
                  prefix="$"
                  style={{ width: '100%' }}
                  formatter={formatInputNumber}
                  parser={parseInputNumber}
                  onChange={(val) => handlePriceChange("purchase", { purchase_price: val })}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={{ span: purchaseDiscountValue > 0 ? 8 : 12 }}>
              <Form.Item
                label="Precio de compra completo"
                name="purchase_price_full"
                rules={[{ required: true, message: 'Por favor ingrese un valor' }]}
              >
                <InputNumber
                  placeholder="Ingresa el valor"
                  disabled
                  prefix="$"
                  style={{ width: '100%' }}
                  min={0}
                  formatter={formatInputNumber}
                  parser={parseInputNumber}
                />
              </Form.Item>
            </Col>
            {purchaseDiscountValue > 0 && (
              <Col xs={24} sm={{ span: 8 }}>
                <Form.Item
                  label="Precio con descuento"
                  name="purchase_price_net"
                  rules={[{ required: true, message: 'Por favor ingrese un valor' }]}
                >
                  <InputNumber
                    placeholder="Ingresa el valor"
                    disabled
                    prefix="$"
                    style={{ width: '100%' }}
                    min={0}
                    formatter={formatInputNumber}
                    parser={parseInputNumber}
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
        </Col>
      )}

      <Col xs={24} sm={{span:20,offset:2}}>
        <Form.Item
          label="Descripción"
          name="description"
          rules={[{ required: true, message: 'Por favor ingresa la descripción' }]}
        >
          <TextArea placeholder="Ingresa la descripción" autoSize={{ minRows: 2, maxRows: 6 }}/>
        </Form.Item>
      </Col>
    </Row>

    {/* Sección Colapsable para Opciones Avanzadas */}
    <Row gutter={[10, 10]} style={{ marginTop: '0.5rem' }}>
      <Col xs={24} sm={{ span: 20, offset: 2 }}>
        <Collapse
          defaultActiveKey={defaultActiveCollapse}
          style={{ borderRadius: '8px', background: '#fafafa', border: '1px solid #d9d9d9' }}
          items={[
            {
              key: 'advanced-options',
              forceRender: true,
              label: (
                <span style={{ fontWeight: 600, color: '#1890ff', fontSize: '0.95rem' }}>
                  <SettingOutlined style={{ marginRight: '8px' }} />
                  Campos adicionales y opciones avanzadas
                </span>
              ),
              children: (
                <div style={{ padding: '0 8px' }}>
                  {/* Identificación y Codificación */}
                  <h6 style={{ fontWeight: 600, color: '#595959', marginBottom: '0.75rem' }}>Identificación y Codificación</h6>
                  <Row gutter={[10, 10]}>
                    <Col xs={24} sm={{ span: 6 }}>
                      <Form.Item label="Identificador" name="custom_id">
                        <Input placeholder="Ingresa identificador" disabled={mod === modules.EditStorageItem && currentRegister?.custom_id !== undefined && currentRegister?.custom_id.length > 0} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={{ span: 6 }}>
                      <Form.Item label="Código de barras" name="barcode">
                        <Input
                          disabled={isBarcodeDisabled}
                          placeholder="Ingresa código de barras"
                          suffix={<BarcodeOutlined onClick={() => !isBarcodeDisabled && setIsScannerOpen(true)} style={{ cursor: isBarcodeDisabled ? "not-allowed" : "pointer", color: isBarcodeDisabled ? "#bfbfbf" : "#1890ff" }} />}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={{ span: 6 }}>
                      <Form.Item label="SKU" name="sku">
                        <Input placeholder="Ingresa sku" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={{ span: 6 }}>
                      <Form.Item label="Cantidad mínima" name="min_quantity" tooltip="Alerta cuando las existencias estén por debajo de este valor">
                        <InputNumber placeholder="0" min={0} style={{ width: '100%' }} />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* Trazabilidad y Control Individual */}
                  <Row gutter={[10, 10]} style={{ marginTop: '8px', marginBottom: '8px' }}>
                    <Col xs={24}>
                      <div style={{ background: '#f0f5ff', padding: '10px 14px', borderRadius: '6px', border: '1px solid #adc6ff' }}>
                        <Form.Item
                          name="is_traceable"
                          valuePropName="checked"
                          style={{ margin: 0 }}
                          tooltip="Marque esta opción si cada unidad de este producto debe ser registrada con identificador individual (número de serie, chapeta, placa o lote) en el módulo de Trazabilidad."
                        >
                          <Checkbox>
                            <span style={{ fontWeight: 600, color: '#1d39c4' }}>
                              ¿Maneja Trazabilidad / Identificación Individual (Serial, Chapeta, Placa o Lote)?
                            </span>
                          </Checkbox>
                        </Form.Item>
                        <div style={{ fontSize: '12px', color: '#595959', marginTop: '4px', marginLeft: '24px' }}>
                          Permite gestionar el historial de eventos, pesajes, tratamientos o ubicaciones individuales desde el módulo de Trazabilidad.
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Divider style={{ margin: '12px 0' }} />

                  {/* Categorización y Clasificación */}
                  <h6 style={{ fontWeight: 600, color: '#595959', marginBottom: '0.75rem' }}>Categorización y Clasificación</h6>
                  <Row gutter={[10, 10]}>
                    <Col xs={24} sm={{ span: 12 }}>
                      <Form.Item label="Categoría" name="category">
                        <Select placeholder="Selecciona categoría">
                          {categories.map((v) => <Option key={v.key} value={v.key}>{v.string_value}</Option>)}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={{ span: 12 }}>
                      <Form.Item label="Unidad de medida" name="measure_unit">
                        <Select placeholder="Selecciona unidad">
                          {ums.map((v) => <Option key={v.key} value={v.key}>{v.string_value}</Option>)}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={{ span: 12 }}>
                      <Form.Item label="Presentación" name="display">
                        <Select placeholder="Selecciona presentación">
                          {presentations.map(v => <Option key={v.key} value={v.key}>{v.string_value}</Option>)}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={{ span: 12 }}>
                      <Form.Item label="Ubicación" name="location">
                        <Input placeholder="Ubicación - Estante" style={{ width: '100%' }} />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Divider style={{ margin: '12px 0' }} />

                  {/* Impuestos y Descuentos */}
                  {(checkedList.includes("SALE") || checkedList.includes("PURCHASE")) && (
                    <>
                      <h6 style={{ fontWeight: 600, color: '#595959', marginBottom: '0.75rem' }}>Impuestos y Descuentos</h6>
                      <Row gutter={[10, 10]}>
                        {checkedList.includes("SALE") && (
                          <Col xs={24} sm={{ span: 12 }}>
                            <Form.Item
                              label="Descuento Venta (%)"
                              name="sell_discount"
                              tooltip="Porcentaje de descuento aplicable entre 0% y 100% (Ej: 10 para 10%)"
                              rules={[{ required: true, message: 'Por favor ingrese un valor' }]}
                            >
                              <InputNumber
                                placeholder="0% (Ej. 10)"
                                onChange={(val) => handlePriceChange("sell", { sell_discount: val })}
                                suffix="%"
                                min={0}
                                max={100}
                                formatter={formatInputNumber}
                                parser={parseInputNumber}
                                style={{ width: '100%' }}
                              />
                            </Form.Item>
                            {sellTaxes.map((impuesto, index) => (
                              <Row key={impuesto.id} gutter={[10, 10]} align="middle">
                                <Col span={16}>
                                  <Form.Item label={index === 0 ? "Impuesto Venta" : ""} name={`sell_taxes_${impuesto.id}`}>
                                    <Select
                                      allowClear
                                      placeholder="Selecciona impuesto"
                                      disabled={isFieldDisabled(impuesto.id, "sell_taxes")}
                                      onChange={(val) => handlePriceChange("sell", { [`sell_taxes_${impuesto.id}`]: val })}
                                    >
                                      {sellTaxesOptions.map((element) => (
                                        <Option key={element.key} value={element.key} disabled={disabledOption(element.key, "sell_taxes")}>{element.string_value}</Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={8} style={{ marginTop: index === 0 ? "16px" : "-12px", display: "flex", alignItems: "center", gap: "8px" }}>
                                  {impuesto.id > 0 && (
                                    <Form.Item name={`sell_taxes_active_${impuesto.id}`} valuePropName="checked" style={{ margin: 0, paddingTop: '8px' }}>
                                      <Checkbox onChange={(e) => handlePriceChange("sell", { [`sell_taxes_active_${impuesto.id}`]: e.target.checked })} />
                                    </Form.Item>
                                  )}
                                  {sellTaxes.length > 0 ? (
                                    <MinusCircleOutlined onClick={() => removeSellTaxes(impuesto.id)} />
                                  ) : null}
                                </Col>
                              </Row>
                            ))}
                            {sellTaxesWarning && <Alert message="Seleccione un valor antes de añadir otro campo" banner closable onClose={() => setSellTaxesWarning(false)} />}
                            <Button type="dashed" size="small" style={{ marginTop: "5px" }} onClick={() => scanForEmptyFields(sellTaxes, setSellTaxes, setSellTaxesWarning, 'sell_taxes')}>Agregar Impuesto Venta</Button>
                          </Col>
                        )}

                        {checkedList.includes("PURCHASE") && (
                          <Col xs={24} sm={{ span: 12 }}>
                            <Form.Item
                              label="Descuento Compra (%)"
                              name="purchase_discount"
                              tooltip="Porcentaje de descuento aplicable entre 0% y 100% (Ej: 10 para 10%)"
                              rules={[{ required: true, message: 'Por favor ingrese un valor' }]}
                            >
                              <InputNumber
                                placeholder="0% (Ej. 10)"
                                onChange={(val) => handlePriceChange("purchase", { purchase_discount: val })}
                                suffix="%"
                                min={0}
                                max={100}
                                formatter={formatInputNumber}
                                parser={parseInputNumber}
                                style={{ width: '100%' }}
                              />
                            </Form.Item>
                            {purchaseTaxes.map((impuesto, index) => (
                              <Row key={impuesto.id} gutter={[10, 10]} align="middle">
                                <Col span={16}>
                                  <Form.Item label={index === 0 ? "Impuesto Compra" : ""} name={`purchase_taxes_${impuesto.id}`}>
                                    <Select
                                      allowClear
                                      placeholder="Selecciona impuesto"
                                      disabled={isFieldDisabled(impuesto.id, "purchase_taxes")}
                                      onChange={(val) => handlePriceChange("purchase", { [`purchase_taxes_${impuesto.id}`]: val })}
                                    >
                                      {purchaseTaxesOptions.map((element) => (
                                        <Option key={element.key} value={element.key} disabled={disabledOption(element.key, "purchase_taxes")}>{element.string_value}</Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={8} style={{ marginTop: index === 0 ? "16px" : "-12px", display: "flex", alignItems: "center", gap: "8px" }}>
                                  {impuesto.id > 0 && (
                                    <Form.Item name={`purchase_taxes_active_${impuesto.id}`} valuePropName="checked" style={{ margin: 0, paddingTop: '8px' }}>
                                      <Checkbox onChange={(e) => handlePriceChange("purchase", { [`purchase_taxes_active_${impuesto.id}`]: e.target.checked })} />
                                    </Form.Item>
                                  )}
                                  {purchaseTaxes.length > 0 ? (
                                    <MinusCircleOutlined onClick={() => removePurchaseTaxes(impuesto.id)} />
                                  ) : null}
                                </Col>
                              </Row>
                            ))}
                            {purchaseTaxesWarning && <Alert message="Seleccione un valor antes de añadir otro campo" banner closable onClose={() => setPurchaseTaxesWarning(false)} />}
                            <Button type="dashed" size="small" style={{ marginTop: "5px" }} onClick={() => scanForEmptyFields(purchaseTaxes, setPurchaseTaxes, setPurchaseTaxesWarning, 'purchase_taxes')}>Agregar Impuesto Compra</Button>
                          </Col>
                        )}
                      </Row>
                      <Divider style={{ margin: '12px 0' }} />
                    </>
                  )}

                  {/* Equivalencia y Fraccionamiento */}
                  <h6 style={{ fontWeight: 600, color: '#595959', marginBottom: '0.75rem' }}>Equivalencia y Fraccionamiento</h6>
                  <Row gutter={[10, 10]}>
                    <Col xs={24} sm={{ span: 10 }}>
                      <Form.Item label="Factor de conversión" name="conversion_factor" tooltip="¿Cuántas unidades individuales contiene esta presentación? Ej: un Six Pack contiene 6 unidades">
                        <InputNumber placeholder="Ej. 6, 12, 24" style={{ width: '100%' }} min={1} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={{ span: 14 }}>
                      <Form.Item label="Producto contenido (unidad individual)" name="parent_element_id" tooltip="Si esta presentación es un empaque que contiene unidades de otro producto, selecciónalo aquí. Solo se muestran productos físicos inventariables.">
                        <Select
                          allowClear
                          showSearch
                          placeholder="Buscar producto individual contenido..."
                          optionLabelProp="label"
                          popupMatchSelectWidth={false}
                          styles={{ popup: { root: { minWidth: 420, maxWidth: 580 } } }}
                          filterOption={(input, option) => {
                            const item = eligibleParentItems.find((i: any) => i.id === option?.value);
                            if (!item) return false;
                            const searchLower = input.toLowerCase();
                            const nameMatch = (item.name || '').toLowerCase().includes(searchLower);
                            const skuMatch = (item.sku || '').toLowerCase().includes(searchLower);
                            const customIdMatch = (item.custom_id || '').toLowerCase().includes(searchLower);
                            const barcodeMatch = (item.barcode || '').toLowerCase().includes(searchLower);
                            const categoryMatch = (item.category || '').toLowerCase().includes(searchLower);
                            return nameMatch || skuMatch || customIdMatch || barcodeMatch || categoryMatch;
                          }}
                        >
                          {eligibleParentItems.map((item: any) => {
                            const totalStock = item.inventory?.reduce((sum: number, inv: any) => sum + (inv.quantity || 0), 0) ?? item.quantity ?? 0;
                            const code = item.custom_id || item.sku;
                            const umName = register.umOptions?.find((u: any) => u.key === item.measure_unit)?.string_value || item.measure_unit || 'UND';
                            const categoryName = categories.find((c: any) => c.key === item.category)?.string_value || item.category;
                            const labelText = `${item.name}${code ? ` (${code})` : ''} - ${umName}`;

                            return (
                              <Select.Option key={item.id} value={item.id} label={labelText} style={{ padding: '6px 12px', height: 'auto' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', whiteSpace: 'normal' }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
                                    <span style={{ fontWeight: 600, color: '#262626', fontSize: '13px', lineHeight: 1.3 }}>
                                      {item.name}
                                    </span>
                                    <Tag color="blue" style={{ margin: 0, fontSize: '11px', lineHeight: '18px', padding: '0 6px', flexShrink: 0 }}>
                                      {umName}
                                    </Tag>
                                  </div>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '11px', color: '#8c8c8c' }}>
                                    <Space size="small">
                                      {code && <span>Código: <strong>{code}</strong></span>}
                                      {categoryName && <span>• {categoryName}</span>}
                                    </Space>
                                    <span style={{ color: totalStock > 0 ? '#52c41a' : '#faad14', fontWeight: 500 }}>
                                      Stock: {totalStock} {umName}
                                    </span>
                                  </div>
                                </div>
                              </Select.Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Divider style={{ margin: '12px 0' }} />

                  {/* Datos Adicionales Personalizados */}
                  <h6 style={{ fontWeight: 600, color: '#595959', marginBottom: '0.75rem' }}>Datos Adicionales Personalizados</h6>
                  {otherValues.map((valor, index) => (
                    <Row key={valor.id} gutter={[10, 10]} align="middle">
                      <Col span={10}>
                        <Form.Item label={index === 0 ? "Nombre de dato" : ""} name={`otherValues_type_${valor.id}`}>
                          <Input placeholder="Ingrese el nombre" style={{ width: '100%' }} disabled={isFieldDisabled(valor.id, "otherValues_visible")} />
                        </Form.Item>
                      </Col>
                      <Col span={10}>
                        <Form.Item label={index === 0 ? "Valor de dato" : ""} name={`otherValues_value_${valor.id}`}>
                          <Input placeholder="Ingrese el valor" style={{ width: '100%' }} disabled={isFieldDisabled(valor.id, "otherValues_visible")} />
                        </Form.Item>
                      </Col>
                      <Col span={4} style={{ marginTop: index === 0 ? "20px" : "-8px", display: "flex", alignItems: "center", gap: "8px" }}>
                        {valor.id > 0 && (
                          <Form.Item name={`otherValues_visible_${valor.id}`} valuePropName="checked" style={{ margin: 0, paddingTop: '6px' }}>
                            <Checkbox />
                          </Form.Item>
                        )}
                        {otherValues.length > 0 ? (
                          <MinusCircleOutlined onClick={() => removeOtherValues(valor.id)} />
                        ) : null}
                      </Col>
                    </Row>
                  ))}
                  {otherValuesWarning && <Alert message="Seleccione un valor antes de añadir otro campo" banner closable onClose={() => setOtherValuesWarning(false)} />}
                  <Button type="dashed" size="small" style={{ marginTop: "5px" }} onClick={() => scanForEmptyFields(otherValues, setOtherValues, setOtherValuesWarning, "otherValues")}>Agregar Valor</Button>
                </div>
              )
            }
          ]}
        />
      </Col>
    </Row>

    <BarcodeScannerModal 
      visible={isScannerOpen} 
      onCancel={() => setIsScannerOpen(false)} 
      onScan={(result) => {
        form.setFieldsValue({ barcode: result });
      }}
    />
    </>
  )
}

export default RegisterInventoryItemForm